<template>
    <v-row no-gutters style="background-color: var(--v-background-base);">
        <v-col cols="12">
            <v-row no-gutters class="my-2" ref="control">
                <v-col cols="5" xl="6" lg="6" md="6" sm="12" class="px-2">
                    <ContractDetailPriceChangeFilterControl :filter="filter" />
                </v-col>
                <v-divider vertical></v-divider>
                <v-col cols="6" xl="6" lg="6" md="6" sm="12" class="px-2">
                    <ContractDetailPriceUpdateOperationControl :options="options" :isLoading="isLoading"
                        :taskProgress="taskProgress" @run="run()" />
                </v-col>
            </v-row>
            <v-divider class="mb-2"></v-divider>
        </v-col>
        <v-col>
            <ContractDataGrid ref="contractDataGrid" v-if="payload" :preview="preview" :summary="summary"
                :filter="filter" :content-height="contentHeight" />
        </v-col>
    </v-row>
</template>
<script>
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ClientAPI from '@/api/ClientAPIMixin';
import ContractDataGrid from './ContractDataGrid.vue'
import ContractDetailPriceChangeFilterControl from './ContractDetailPriceChangeFilterControl.vue'
import ContractDetailPriceUpdateOperationControl from './ContractDetailPriceUpdateOperationControl.vue'

export default {
    name: 'ContractDetailPriceUpdate',
    components: {
        ContractDataGrid,
        ContractDetailPriceChangeFilterControl,
        ContractDetailPriceUpdateOperationControl
    },
    mixins: [ClientAPI],
    data() {
        return {
            valid: false,
            priceDate: new Date(),
            payload: [],
            isLoading: false,
            taskProgress: 0,
            taskDisplayText: '',
            filter: {
                Limit: 10,
                ContractStartBefore: new Date(),
                ContractStatus: [1],
                ContractDetailStatus: [1],
                ContractDetailPriceMode: [1],
                ContractTypeIds: [3],
            },
            options: {
                OperationMode: 'add', // or 'delete'
                FixedPrice: 0.0,
                DynamicPricingPercentage: 0.0,
                PriceMode: 'dynamic',
                PriceDate: new Date(),
                InvoiceCommentMode: 'none',
                InvoiceComment: '',
            },
            controlHeight: 0,
        }
    },
    mounted() {
        this.fetch();
        this.subscribe();
        this.updateControlHeight();
    },
    beforeDestroy() {
        this.unSubscribe();
    },
    methods: {
        notifyProgress(args) {
            if (args && args.task && args.task.planName === 'UpdateContractDetailPricePlan') {
                if (args.status == 'completed' || args.status == 'failed') {
                    this.taskProgress = 0;
                    this.taskDisplayText = '';
                    this.isLoading = false;
                    this.options.DynamicPricingPercentage = 0.0;
                    this.options.FixedPrice = 0.0;
                    this.fetch();
                    this.showSnackbar({
                        text: `${this.$t("servicesystem.common_objects.contract.priceupdate")}.`,
                        subtext: args.status === 'completed' ? this.$t("servicesystem.common_objects.contract.completed")
                            : this.$t("servicesystem.common_objects.contract.cancelled"),
                        color: args.status === 'completed' ? 'success' : 'error',
                        icon: args.status === 'completed' ? 'mdi-check-circle' : 'mdi-alert-circle'
                    });
                } else {
                    this.taskProgress = args.progress ?? 0;
                    this.taskDisplayText = args.displayText;
                    this.isLoading = true;
                }
                this.updateControlHeight();
            }
        },
        subscribe() {
            this.$store.dispatch("NotificationStore/subscribe", [SRConst.EventKeys.TaskEvent, this.notifyProgress]);
        },
        unSubscribe() {
            this.$store.dispatch("NotificationStore/unsubscribe", [SRConst.EventKeys.TaskEvent, this.notifyProgress]);
        },
        updateControlHeight() {
            if (this.$refs.control) {
                this.$nextTick(() => {
                    this.controlHeight = this.$refs.control.offsetHeight + 8;
                });
            }
        },
        run() {
            this.isLoading = true;
            ClientAPI.methods.updateContractDetailPrices(this.asDto())
                .then((response) => {
                    if (response == '') {
                        this.isLoading = false;
                        this.displayText = this.$t('servicesystem.common_objects.task.task-did-not-start');
                    }
                }).catch(() => {
                    this.isLoading = false;
                });
        },
        asDto() {
            return {
                ...this.options,
                ContractStartBefore: this.filter.ContractStartBefore,
                ContractStatus: this.filter.ContractStatus,
                ContractDetailStatus: this.filter.ContractDetailStatus,
                ContractDetailPriceMode: this.filter.ContractDetailPriceMode,
            };
        },
        fetch() {
            ClientAPI.methods.getContractDetailsWithLatestPriceFromFilter(this.filter).then((response) => {
                this.payload = response;
            }).then(() => {
                this.$refs.contractDataGrid.refresh();
            });
        }
    },
    computed: {
        summary() {
            return {
                totalCount: this.payload?.TotalCount || 0,
                totalSum: this.payload?.TotalSum * 12 || 0
            }
        },
        preview() {
            if (this.options.OperationMode !== 'add') {
                return { mode: null }
            }

            return {
                mode: this.options.PriceMode,
                fixedPrice: this.options.FixedPrice,
                dynamicPricingPercentage: this.options.DynamicPricingPercentage
            }
        },
        contentHeight() {
            return this.$store.getters['navstore/ContentContainerHeight'] - this.controlHeight - 17 + 'px';
        },
    },
    watch: {
        filter: {
            deep: true,
            handler() {
                this.fetch();
            }
        },
        options: {
            deep: true,
            handler() {
                this.updateControlHeight();
            }
        }
    }
};
</script>